import {reactive} from 'vue';

export const store = reactive({
    apiUrl: process.env.NODE_ENV === 'production' ? '/wp-admin/admin-ajax.php' : 'http://dk-tpl.test/wp-admin/admin-ajax.php',
    botName: '',
    botImageUrl: '',
    loading: true,
    error: null,
    messages: {},
    formId: null,
    session: null,
    isTypingDelay: 800,
    beforeNextMsgDelay: 200,
    afterMsgOnlyDelay: 50,
    beforeScrollDelay: 300,
    userHasInvolved: false,
    scrollTo: 'no-scroll',
    gtmEvents: {
        start: null,
        submit: null,
    },

    startBot(formId, botName=null, botImageUrl=null, gtmEvents={}) {
        this.session = (Math.random()).toString(36).substring(2);
        this.formId = formId;
        this.botName = botName ?? this.botName;
        this.botImageUrl = botImageUrl ?? this.botImageUrl;
        this.gtmEvents = gtmEvents ?? {};

        this.post({
            action: 'wpbot_get_form',
        }).then((data) => {
            this.showMessage(data, 'no-scroll');
            this.loading = false;
        });
    },

    gtmPush(gtmEvent) {
        if (window.dataLayer) {
            window.dataLayer.push({
                "event": gtmEvent,
                "botId": this.formId,
            });
        }
    },

    showMessage(data, setScrollTo = null) {
        //if (data.status === 'complete' && window.dataLayer && this.gtmEvents.submit) {
        if (data.status === 'complete' && this.gtmEvents.submit) {
            this.gtmPush(this.gtmEvents.submit);
        }

        if (data.status === 'complete' || this.error) return;

        this.messages[data.ID] = { isTyping: true };

        this.scrollTo = setScrollTo ?? 'is_typing';

        setTimeout(() => this._buildMessage(data, setScrollTo), this.userHasInvolved ? this.isTypingDelay : 1);
    },

    _buildMessage(data, setScrollTo = null) {
        const scrollTo =  setScrollTo ?? data.ID;

        if (data.type === 'html') {
            let theScript = (data.config?.default ?? '')
                .replace(/\n/gm, "")
                .match(/<!-- dk-bot-script:(.*?)-->/);

            if (theScript) {
                data.scriptToRun = theScript;
                data.config.default = data.config.default
                    .replace(/\n/gm, "")
                    .replace(/<!-- dk-bot-script:(.*?)-->/, "");
            }

            //setTimeout(() => this.scrollTo = scrollTo, this.beforeScrollDelay);

            this.messages[data.ID] = data;

            setTimeout(() => {
                const answer = document.querySelector('.dk--bot-msg-' + data.ID)?.innerHTML
                        .replace(/(\r\n|\r|\n)/g, "\n")
                    ?? null;

                console.log({ htmlMessage: 'yes', data, answer });

                this.nextMessage(data.ID, answer, this.afterMsgOnlyDelay, scrollTo);
            }, 180);

            return;
        }

        this.messages[data.ID] = data;

        if (scrollTo !== 'no-scroll') {
            setTimeout(() => this.scrollTo = scrollTo, this.beforeScrollDelay);
        }
    },

    nextMessage(fieldid, answer = null, delay = this.beforeNextMsgDelay, scrollTo = null) {
        const setScrollTo = delay === 0 ? 'no-scroll' : null;

        if (typeof answer === 'string') {
            if (answer.match(/^link:/)) {
                window.location = answer.substring(5);
                return;
            }
            if (answer.match(/^startbot[:|_]/)) {
                this.startBot(answer.substring(9));
                return;
            }
        }

        this.post({
            fieldid,
            answer
        }).then((data) => {
            setTimeout(() => {
                this.showMessage(data, setScrollTo);
                this.scrollTo = scrollTo;
            }, delay);
        });
    },

    sendAnswer(fieldid, answer = null) {
        if (!this.userHasInvolved && this.gtmEvents.start) {
            this.gtmPush(this.gtmEvents.start);
        }

        this.userHasInvolved = true;

        this.messages[fieldid]['answered'] = true;
        this.messages[fieldid]['answer'] = answer;

        this.nextMessage(fieldid, answer);
    },

    async post(data = {}, nthTry = 0) {
        data.session = this.session;
        data.formid = this.formId;
        data.action = data.action ?? 'wpbot_capture_form_value';

        try {
            const response = await fetch(this.apiUrl, {
                method: "POST",
                mode: "cors",
                cache: "no-cache",
                credentials: "same-origin",
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                },
                redirect: "follow",
                referrerPolicy: "strict-origin-when-cross-origin",
                body: new URLSearchParams(data).toString(),
            });

            return await response.json();
        } catch (error) {
            if (nthTry <= 3) {
                return this.post(data, nthTry++);
            }

            console.error(`Bot POST error: ${error.message}`);
            this.error = error.message;

            return false;
        }
    }
});